import React, { useState } from "react";
import Shipment from "./Shipment";
const CompletedShipments = () => {
  const [searchParams, setSearchParams] = useState({
    blNumber: "",
    status: "transferred",
    page: 1,
    limit: 10,
    sort: { field: "eta", order: 1 },
  });
  const tableHeaders = [
    "BL Number",
    "Vessel Details",
    "SKU's",
    "Container Number",
    "Seal Number",
    "ETD(dd/mm/yyyy)",
    "ETA(dd/mm/yyyy)",
    "Unload Date(Approx)(dd/mm/yyyy)",
    "Status",
  ];
  const header = "Completed Shipments";

  return (
    <Shipment
      searchParams={searchParams}
      tableHeaders={tableHeaders}
      completed={true}
      setSearchParams={setSearchParams}
      header={header}
    />
  );
};
export default CompletedShipments;
